import { HOST, } from "common/constants";
import { Box, Divider, useMediaQuery } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import axios from "axios";

import Empty from "components/Empty/Empty";
import { NewsCard } from "components/NewsCard";
import { SkeletonCard } from "components/SkeletonCard";

import classes from "./newsList.module.scss";

const InfoList = (props) => {
  const {
    variant = "grid",
    count = 8,
    itemProps = { variant: "flexCard", button: false, titleLength: 80 },
    itemDivider = false,
    page = "news",
  } = props;

  const isTable = useMediaQuery("(max-width: 820px)");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const skeletonItemsCount = count >= 100 ? 10 : count;

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get(
          `${HOST}/api/v1/usefulinformation/`,
          {
            params: {
              limit: count,
              offset: 0,
            },
          }
        );

        setData(res.data.results || []);
      } catch (err) {
        console.error("Ошибка при получении новостей:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [count]);

  if (loading) {
    return (
      <Box className={classes[variant]}>
        {[...Array(skeletonItemsCount)].map((_, idx) => (
          <SkeletonCard
            className={classes[itemProps.variant]}
            key={idx}
            height={"200px"}
          />
        ))}
      </Box>
    );
  }

  return (
    <Box className={classes[variant]}>
      {data?.length > 0 ? (
        data?.slice(0, count)?.map((item) => (
          <Fragment key={item.id}>
            {isTable ? (
              <NewsCard {...itemProps} item={item} page={page} />
            ) : (
              <NewsCard
                {...itemProps}
                variant={itemProps.variant}
                item={item}
                page={page}
              />
            )}
            {itemDivider && <Divider sx={{ width: "100%" }} />}
          </Fragment>
        ))
      ) : (
        <Empty />
      )}
    </Box>
  );
};

export default InfoList;
